module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register textSection"
  }, [_c('h1', [_vm._v("Profil utilisateur")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Sur cette page vous pourrez suivre et éditer votre profil utilisateur.")]), _vm._v(" "), _c('form', [_c('label', [_vm._v("Mon adresse email")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "name@example.com"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Changer mon mot de passe")]), _vm._v(" "), _c('label', [_vm._v("Mon ancien mot de passe")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "required": "required",
      "placeholder": "******"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Nouveau mot de passe")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "required": "required",
      "placeholder": "******"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Confirmer mot de passe")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "required": "required",
      "placeholder": "******"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mettre à jour")])])]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Suivi de mes formations")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("bla")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f464fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 451
// module chunks = 1